// Ekran 02 — Mal Kabul API istemcisi.

import { api } from '../../lib/api'

export type LotDurumu = 'taslak' | 'onayli' | 'reddedildi' | 'storno'

export type LotOzet = {
  id: string
  belgeNo: string
  zaman: string
  havuzId: string
  cariId: string
  cariKod: string
  cariUnvan: string
  stokKartiId: string
  stokKod: string
  stokAd: string
  /** K19: hijyen bayraklı substrat — tabloda uyarı ikonu. */
  hij: boolean
  irsaliyeNo: string | null
  plaka: string | null
  surucu: string | null
  brut: number | null
  dara: number | null
  net: number | null
  birimFiyat: number | null
  durum: LotDurumu
  stornoEdildi: boolean
  redGerekce: string | null
  numuneNo: string | null
  /** Rozet analiz sekmesini açar (`n-<id>`); numune yoksa null. */
  numuneId: string | null
}

export type LotPotansiyeli = {
  biyogaz: number | null
  metan: number | null
  elektrik: number | null
  /** K31: "bmp" · "ch4" · "yok". */
  metanKaynagi: string
}

export type LotDetay = {
  lot: LotOzet
  haoOncesi: number | null
  haoSonrasi: number | null
  bakiyeSonrasi: number | null
  potansiyel: LotPotansiyeli
}

export type MalKabulOzeti = {
  bugunKabul: number
  bugunTonaj: number | null
  taslakBekleyen: number
  analizBekleyen: number
  redEdilen: number
  buAyTonaj: number | null
  buAyKayit: number
  numunesizKabul: number
}

export type LotIstek = {
  /** Eşleşmenin havuzu varsa kimliği; yoksa boş uuid + cari/stok çifti. */
  havuzId: string
  plaka?: string | null
  surucu?: string | null
  brut?: number | null
  dara?: number | null
  birimFiyat?: number | null
  /**
   * Havuzu olmayan eşleşme için (K27 — ilk LOT'ta havuz doğar). Sunucu bu
   * çiftten havuzu bulur ya da açar; istemci havuz açmıyor.
   */
  cariId?: string
  stokKartiId?: string
}

export const lotlar = {
  liste: (s: { durum?: LotDurumu; q?: string } = {}) => {
    const p = new URLSearchParams()
    if (s.durum) p.set('durum', s.durum)
    if (s.q) p.set('q', s.q)
    const qs = p.toString()
    return api<LotOzet[]>(`/api/lotlar${qs ? `?${qs}` : ''}`)
  },

  ozet: () => api<MalKabulOzeti>('/api/lotlar/ozet'),

  sayaclar: () => api<{ durum: LotDurumu; adet: number }[]>('/api/lotlar/sayaclar'),

  detay: (id: string) => api<LotDetay>(`/api/lotlar/${id}`),

  olustur: (govde: LotIstek) => api<LotOzet>('/api/lotlar', { yontem: 'POST', govde }),

  /**
   * TASLAĞI siler. Onaylı/reddedilmiş/stornolu kayıt 409 döner (K15) —
   * onaylıyı geri almanın yolu storno.
   */
  sil: (id: string) =>
    api<{ silindi: boolean; belgeNo: string }>(`/api/lotlar/${id}`, { yontem: 'DELETE' }),

  guncelle: (id: string, govde: LotIstek) =>
    api<LotOzet>(`/api/lotlar/${id}`, { yontem: 'PUT', govde }),

  onayla: (id: string) =>
    api<{
      lot: LotOzet
      haoOncesi: number | null
      haoSonrasi: number | null
      bakiyeSonrasi: number | null
      mesaj: string
    }>(`/api/lotlar/${id}/onayla`, { yontem: 'POST' }),

  reddet: (id: string, gerekce: string) =>
    api<LotOzet>(`/api/lotlar/${id}/reddet`, { yontem: 'POST', govde: { gerekce } }),

  storno: (id: string, gerekce: string) =>
    api<{ stornoBelgeNo: string; bakiyeSonrasi: number | null; mesaj: string }>(
      `/api/lotlar/${id}/storno`,
      { yontem: 'POST', govde: { gerekce } },
    ),
}
